import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { CookieConsentBannerComponent } from './components/cookie-consent/cookie-consent-banner.component';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, CookieConsentBannerComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent {}
